import { Component, EventEmitter, Input, Output } from '@angular/core';

import { ISimpleItem } from '@core/models/simple-item.model';

@Component({
  selector: 'app-horizontal-filter-list-atom',
  templateUrl: './horizontal-filter-list-atom.component.html',
  standalone: false,
})
export class HorizontalFilterListAtomComponent {
  @Input() items!: ISimpleItem[];
  @Input() text!: string;

  @Output() clickItem = new EventEmitter<ISimpleItem>();
}
